<template>
	<div>
	
	<van-row type="flex" class="topdiv" justify-content="center"  flex-direction= "column">
		 <van-col span="6"><van-icon :name="feedback" size="60px"></van-icon></van-col>
	  <van-col span="18" class="title">我的订单</van-col>
	 </van-row>
	
	<div class="Content">
		<van-steps
		  :active="active"
		  active-icon="success"
		  active-color="#38f"		  
		>
		  <van-step>验证设备</van-step>
		  <van-step>选择产品</van-step>
		  <van-step>填写订单</van-step>
		  <van-step>订单支付</van-step>
		</van-steps>
		
		<van-divider content-position="left">第一步：验证打印机的型号及购买日期。</van-divider>
		<van-search
		  v-model="value"
		  shape="round"
		  background="#ffffff"
		  placeholder="请输入打印机的序列号"
		/>
		<van-field label="产品名称:" type="textarea" rows="2"
		:value="printerinfo.ProductName" readonly label-class="itemLabel"/>
		<van-field label="P/N:" :value="printerinfo.ProductCode" readonly label-class="itemLabel"/>
		<van-field label="产品型号:" :value="printerinfo.Model" readonly label-class="itemLabel"/>
		<van-field label="出厂日期:" :value="printerinfo.scan_date" readonly label-class="itemLabel"/>
		<van-field label="购买日期:" :value="printerinfo.buydate" label-class="itemLabel"/>
		<van-divider content-position="center">录入发票、机身信息</van-divider>
		<van-grid :column-num="2">
		  <van-grid-item icon="plus" text="机身条码" info="0" />
		  <van-grid-item icon="plus" text="发票收据" info="0" />
		</van-grid>
		 <van-button type="danger" class="btnNext" to = "/oow/mypros">下一步</van-button>
	</div>
</div>
</template>

<script>
	export default {
	  name: 'NEWOOWSO',	  
	  data(){
	  		return{		
				feedback: require("@/assets/icon/oow.png"),
				active: '0',	
				printerinfo:[]
	  		}
	  	 
	  }
	}
</script>

<style>
	.Content{
		background-color: #ffffff;
		margin-top:2px;
		
	}
	.itemLabel{
		font-weight: bold;
	}
	.btnNext{
		width: 95%;
		border-radius: 5px;
	}
</style>
